import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import SaleInputs from './Sale';

import Name from './Name';
import Title from '../../../../common/RequestTitle';
class SalesOrder extends React.Component {
    constructor(props) {
        super(props);

        this.state = {};
    }
    
    render() {
        return (
            <div className='sidebar-table'>
                <Title 
                    orderNumber={this.props.numberSaleTable + 1}
                    text='VESSEL SALE NUMBER'
                    warnings={this.props.vesselSale.warnings}
                />
                <Name numberSaleTable={this.props.numberSaleTable} />
                <hr/>
                <SaleInputs numberSaleTable={this.props.numberSaleTable} />
            </div>
        );
    }
}

export default connect(
    (state, ownProps) => {

        const vesselSale = state.vesselSales.items[ownProps.numberSaleTable];

        return {
            numberSaleTable: ownProps.numberSaleTable,
            vesselSale,
            message: vesselSale.successMessage.message ? vesselSale.successMessage.message : '',
        };
    },
    dispatch => bindActionCreators({
        // clearMessage,
    }, dispatch),
)(SalesOrder);



// WEBPACK FOOTER //
// ./app/components/Letters/Single/Sales/Order/SalesOrder.jsx